import React from 'react';
import { connect } from 'react-redux';
import { compose, withPropsOnChange } from 'recompose';
import { UserService } from '../../../../../services/user-service';
import { sortByWeight } from '../../../../../helpers/array';
import { Cards } from './cards';
import { List } from './list';

const sections = {
  list: List
};

const SectionComponent = props => {
  if (sections[props.name]) {
    const Section = sections[props.name];

    return <Section {...props} />;
  }

  return <Cards {...props} />;
};

const SECTIONS_GUARDS = {
  '/account/details': () => UserService.hasUser(),
  '/account/marketing': ({ marketingLists }) => {
    const hasLists = marketingLists.length > 0;

    if (UserService.hasUser()) {
      return hasLists;
    } else {
      return hasLists && marketingLists.some(({ nonRegisteredEnabled }) => nonRegisteredEnabled);
    }
  }
};

export const Section = compose(
  connect(state => ({
    marketingLists: state.marketingLists.lists
  })),
  withPropsOnChange([], ({ items, ...props }) => ({
    items: sortByWeight(
      items.filter(({ to }) => {
        return SECTIONS_GUARDS[to] ? SECTIONS_GUARDS[to](props) : to;
      })
    )
  }))
)(SectionComponent);
